import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider";
import { getHotelSuggestions } from "../../Services/HotelAutoSuggestApi";
import countryData from "../../Services/Country.json";

const capitalizeWords = (str) => {
  if (!str) return "";
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};
const HotelSearch = () => {
  const { corporateId, userName, roles } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [travelType, setTravelType] = useState("BusinessTravel");
  const [corporateCode, setCorporateCode] = useState(
    localStorage.getItem("selectedCorporateCode") || corporateId || "",
  );
  const [corporateTraveler, setCorporateTraveler] = useState(
    localStorage.getItem("selectedUserId") ||
    (Array.isArray(roles) ? roles[0] || "" : roles || ""),
  );

  // Synchronize with localStorage (e.g., when Header modal updates emulation)
  useEffect(() => {
    const syncWithLocalStorage = () => {
      const storedCorpCode = localStorage.getItem("selectedCorporateCode");
      const storedUserId = localStorage.getItem("selectedUserId");

      if (storedCorpCode && storedCorpCode !== corporateCode) {
        setCorporateCode(storedCorpCode);
      }
      if (storedUserId && storedUserId !== corporateTraveler) {
        setCorporateTraveler(storedUserId);
      }
    };

    window.addEventListener("storage", syncWithLocalStorage);
    const interval = setInterval(syncWithLocalStorage, 1000);

    return () => {
      window.removeEventListener("storage", syncWithLocalStorage);
      clearInterval(interval);
    };
  }, [corporateCode, corporateTraveler]);
  // Helper to get date parts for display
  const getDateParts = (date) => {
    return {
      day: ("0" + date.getDate()).slice(-2),
      monthYear: `${date.toLocaleString("default", { month: "short" })}-${date.getFullYear()}`,
      dayName: date.toLocaleDateString("default", { weekday: "long" }),
    };
  };

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const initialDep = getDateParts(today);
  const initialRet = getDateParts(tomorrow);

  const updateDisplay = (idPrefix, date) => {
    const day = ("0" + date.getDate()).slice(-2);
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    const dayName = date.toLocaleDateString("default", { weekday: "long" });

    $(`#${idPrefix}_dayNum`).text(day);
    $(`#${idPrefix}_monthYear`).text(`${month}-${year}`);
    $(`#${idPrefix}_dayName`).text(dayName);
  };

  // ------------------ CHECK-IN DATE ------------------
  useEffect(() => {
    const today = new Date();
    $("#departureDate").datepicker({
      dateFormat: "dd-M-yy",
      appendTo: "#dateDisplay",
      minDate: 0,
      // maxDate: "+4m",
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay").offset();
          const height = $("#dateDisplay").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function () {
        const date = $(this).datepicker("getDate");
        updateDisplay("dep", date);

        // Sync return date: check-out must be at least same day as check-in
        $("#returnDate").datepicker("option", "minDate", date);
        const returnDate = $("#returnDate").datepicker("getDate");

        if (!returnDate || returnDate <= date) {
          const nextDay = new Date(date);
          nextDay.setDate(date.getDate() + 1);
          $("#returnDate").datepicker("setDate", nextDay);
          updateDisplay("ret", nextDay);
        }
      },
    });
    $("#departureDate").datepicker("setDate", today);
    updateDisplay("dep", today);
  }, []);

  // ------------------ CHECK-OUT DATE ------------------
  useEffect(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    $("#returnDate").datepicker({
      dateFormat: "dd-M-yy",
      appendTo: "#dateDisplay2",
      minDate: 0,
      // maxDate: "+4m",
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay2").offset();
          const height = $("#dateDisplay2").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function () {
        const date = $(this).datepicker("getDate");
        updateDisplay("ret", date);
      },
    });
    $("#returnDate").datepicker("setDate", tomorrow);
    updateDisplay("ret", tomorrow);
  }, []);

  // ------------------ PERSISTENCE ------------------
  useEffect(() => {
    const raw = sessionStorage.getItem("hotelSearchData");
    if (!raw) return;
    try {
      const data = JSON.parse(raw);
      if (data.travelType) setTravelType(data.travelType);
      if (data.corporateCode) setCorporateCode(data.corporateCode);
      if (data.corporateTraveler) setCorporateTraveler(data.corporateTraveler);
      if (data.destinationName) {
        setSearchTerm(capitalizeWords(data.destinationName));
        isSelectingRef.current = true; // Prevent suggestions popping up on load
      }
      if (data.selectedLocation) {
        setSelectedLocation(data.selectedLocation);
      }
      if (data.roomGuests && data.roomGuests.length > 0) {
        setRooms(
          data.roomGuests.map((rg) => ({
            adults: rg.noOfAdults || 1,
            children: rg.noOfChilds || 0,
            childAges: rg.childAge || [],
          })),
        );
      }
      if (data.nationality) setNationality(data.nationality);
      if (data.starRatings) {
        setStarRatings(data.starRatings);
      } else if (data.starRating) {
        setStarRatings([data.starRating]);
      }
    } catch (e) {
      console.error("HotelSearch Persistence Error:", e);
    }
  }, []);

  const [nationality, setNationality] = useState("106");
  const [starRatings, setStarRatings] = useState([]);
  const [showStarDropdown, setShowStarDropdown] = useState(false);

  const [rooms, setRooms] = useState([
    { adults: 1, children: 0, childAges: [] },
  ]);

  // ------------------ AUTOCOMPLETE SUGGESTIONS ------------------
  // Powered by HotelAutoSuggestApi.js
  // Scenario 1 (current): USE_MOCK=true  → filters from local mock data
  // Scenario 2 (live API): USE_MOCK=false → calls POST /api/Hotel/AutoSuggest
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const isSelectingRef = React.useRef(false);

  const handleSearchChange = (e) => {
    isSelectingRef.current = false;
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    if (isSelectingRef.current) {
      isSelectingRef.current = false;
      return;
    }

    if (searchTerm.length > 2) {
      const handler = setTimeout(async () => {
        const results = await getHotelSuggestions(searchTerm);
        console.log(results)
        setFilteredSuggestions(results);
        setShowSuggestions(results.length > 0);
      }, 500); // 500ms debounce

      return () => clearTimeout(handler);
    } else {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
    }
  }, [searchTerm]);

  const handleSuggestionSelect = (suggestion) => {
    isSelectingRef.current = true;
    setSearchTerm(suggestion.name);
    setSelectedLocation(suggestion);
    setShowSuggestions(false);
    // console.log("Selected:", suggestion);
  };

  /* ------------------ HANDLERS ------------------ */
  const MAX_ROOMS = 5;

  const addRoom = () => {
    if (rooms.length < MAX_ROOMS) {
      setRooms([...rooms, { adults: 1, children: 0, childAges: [] }]);
    }
  };

  const removeRoom = () => {
    if (rooms.length > 1) {
      setRooms(rooms.slice(0, -1));
    }
  };

  const updateRoom = (index, field, value) => {
    const updated = [...rooms];
    if (field === "children") {
      const newCount = Number(value);
      const currentAges = updated[index].childAges || [];
      if (newCount > currentAges.length) {
        const diff = newCount - currentAges.length;
        updated[index].childAges = [...currentAges, ...Array(diff).fill(1)];
      } else {
        updated[index].childAges = currentAges.slice(0, newCount);
      }
      updated[index][field] = newCount;
    } else if (field === "childAge") {
      const { childIndex, age } = value;
      updated[index].childAges[childIndex] = Number(age);
    } else {
      updated[index][field] = Number(value);
    }
    setRooms(updated);
  };

  const totalGuests = rooms.reduce((sum, r) => sum + r.adults + r.children, 0);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm) {
      alert("Please enter a destination");
      return;
    }

    const checkInDate = $("#departureDate").datepicker("getDate");
    const checkOutDate = $("#returnDate").datepicker("getDate");

    if (checkInDate && checkOutDate && checkOutDate < checkInDate) {
      alert("Check-out date cannot be earlier than Check-in date");
      return;
    }

    let finalHotelIds = [];
    let finalDestinationName = capitalizeWords(searchTerm);

    if (selectedLocation && selectedLocation.name.toLowerCase() === searchTerm.toLowerCase()) {
      finalHotelIds =
        selectedLocation.hotelIds ||
        (selectedLocation.type === "hotel" ? [selectedLocation.id] : []);
      finalDestinationName = selectedLocation.name;
      setSearchTerm(selectedLocation.name);
    } else {
      try {
        const results = await getHotelSuggestions(searchTerm);
        if (results && results.length > 0) {
          const match = results[0];
          finalHotelIds =
            match.hotelIds || (match.type === "hotel" ? [match.id] : []);
          finalDestinationName = match.name;
          setSearchTerm(match.name);
        } else {
          alert(
            "Could not find any matching city or hotel. Please select from the dropdown.",
          );
          return;
        }
      } catch (e) {
        alert("Error fetching location data. Please try again.");
        return;
      }
    }

    const formatDate = (date) => {
      if (!date) return "";
      const y = date.getFullYear();
      const m = ("0" + (date.getMonth() + 1)).slice(-2);
      const d = ("0" + date.getDate()).slice(-2);
      return `${y}-${m}-${d}`;
    };

    const roomGuests = rooms.map((r) => ({
      noOfAdults: Number(r.adults),
      noOfChilds: Number(r.children),
      childAge: r.childAges || [],
    }));

    const searchData = {
      checkInDate: formatDate(checkInDate),
      checkOutDate: formatDate(checkOutDate),
      currency: "INR",
      hotelIds: finalHotelIds,
      roomGuests: roomGuests,
      nationality: nationality,
      starRatings: starRatings,
      traceId: "",
      // Adding these for easy display on result page
      destinationName: finalDestinationName,
      travelType: travelType,
      corporateCode: corporateCode,
      corporateTraveler: corporateTraveler,
      selectedLocation: selectedLocation,
    };
    console.log(searchData);
    sessionStorage.setItem("hotelSearchData", JSON.stringify(searchData));
    navigate("/hotel/result");
  };

  useEffect(() => {
    const close = () => {
      setShowDropdown(false);
      setShowSuggestions(false);
      setShowStarDropdown(false);
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  return (
    <>
      <div className="Hotl_serch">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-6">
            <div className="d-flex">
              {/* Radio Buttons */}
              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="BusinessTravel"
                    id="BusinessTravel"
                    checked={travelType === "BusinessTravel"}
                    onChange={(e) => setTravelType(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="BusinessTravel">
                    Business Travel
                  </label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="PersonalTravel"
                    id="PersonalTravel"
                    checked={travelType === "PersonalTravel"}
                    onChange={(e) => setTravelType(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="PersonalTravel">
                    Personal Travel
                  </label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="GuestTravel"
                    id="GuestTravel"
                    checked={travelType === "GuestTravel"}
                    onChange={(e) => setTravelType(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="GuestTravel">
                    Guest Travel
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="form_ful">
          {/* Destination */}
          <div className="Destnion">
            <p>
              <i className="fa fa-hotel"></i> Enter City, Location, Hotel Name
            </p>
            {/* <input className="form_control_hotel" type="text" defaultValue="" placeholder="Delhi"/> */}

            <div className="detinion">
              <input
                className="form_control_hotel"
                type="text"
                placeholder="Enter City Name.."
                value={searchTerm}
                onChange={handleSearchChange}
                onClick={(e) => {
                  e.stopPropagation();
                  if (searchTerm.length > 2) setShowSuggestions(true);
                }}
                autoComplete="off"
              />
              {showSuggestions && filteredSuggestions.length > 0 && (() => {
                const topSuggestions = filteredSuggestions.filter((item) => item.type === "city");
                const remainingSuggestions = filteredSuggestions.filter((item) => item.type !== "city");
                return (
                  <ul className="autosuggetsList">
                    {/* Cities (Top) */}
                    {topSuggestions.length > 0 && (
                      <>
                        <li
                          className="suggestion-group-header"
                          style={{
                            padding: "8px 12px",
                            background: "#f4f4f4",
                            color: "#110942",
                            fontWeight: "700",
                            fontSize: "12px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            pointerEvents: "none",
                            borderBottom: "1px solid #e2e8f0",
                          }}
                        >
                          Cities / Regions
                        </li>
                        {topSuggestions.map((item, index) => {
                          const regionParts = item.region ? item.region.split(",") : [item.name];
                          const topText = regionParts[0].trim();
                          const remainingText = regionParts.slice(1).join(",").trim();
                          return (
                            <li
                              key={`city-${index}`}
                              onClick={() => handleSuggestionSelect(item)}
                              style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}
                            >
                              <div className="d-flex align-items-center w-100">
                                <i
                                  className="fa fa-map-marker-alt suggestion-icon"
                                  style={{
                                    fontSize: "16px",
                                    color: "#110942",
                                    marginRight: "12px",
                                    width: "20px",
                                    textAlign: "center",
                                  }}
                                ></i>
                                <div style={{ flex: 1 }}>
                                  <div className="font-600" style={{ fontSize: "14px", color: "#110942", fontWeight: "600", textTransform: "capitalize" }}>
                                    {topText}
                                  </div>
                                  {remainingText && (
                                    <div className="fs-11 text-gray-600" style={{ fontSize: "11px", color: "#7E7979", textTransform: "capitalize" }}>
                                      {remainingText}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </li>
                          );
                        })}
                      </>
                    )}

                    {/* Hotels & Remaining */}
                    {remainingSuggestions.length > 0 && (
                      <>
                        <li
                          className="suggestion-group-header"
                          style={{
                            padding: "8px 12px",
                            background: "#f4f4f4",
                            color: "#110942",
                            fontWeight: "700",
                            fontSize: "12px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            pointerEvents: "none",
                            borderBottom: "1px solid #e2e8f0",
                            borderTop: topSuggestions.length > 0 ? "1px solid #e2e8f0" : "none",
                          }}
                        >
                          Hotels
                        </li>
                        {remainingSuggestions.map((item, index) => (
                          <li
                            key={`remaining-${index}`}
                            onClick={() => handleSuggestionSelect(item)}
                            style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}
                          >
                            <div className="d-flex align-items-center w-100">
                              <i
                                className="fa fa-hotel suggestion-icon"
                                style={{
                                  fontSize: "16px",
                                  color: "#dacd65",
                                  marginRight: "12px",
                                  width: "20px",
                                  textAlign: "center",
                                }}
                              ></i>
                              <div style={{ flex: 1 }}>
                                <div className="font-600" style={{ fontSize: "14px", color: "#110942", fontWeight: "600", textTransform: "capitalize" }}>
                                  {item.name}
                                </div>
                                {item.region && (
                                  <div className="fs-11 text-gray-600" style={{ fontSize: "11px", color: "#7E7979", textTransform: "capitalize" }}>
                                    ({item.region})
                                  </div>
                                )}
                              </div>
                            </div>
                          </li>
                        ))}
                      </>
                    )}
                  </ul>
                );
              })()}
            </div>
          </div>

          {/* Check-In */}
          <div className="Destnion_date">
            <p>
              <i className="fa fa-calendar-days"></i> Check-In
            </p>

            <div
              className="dest_nam cursor-pointer"
              id="dateDisplay"
              onClick={() => $("#departureDate").datepicker("show")}
            >
              <span id="dep_dayNum" className="fs-28 font-bold">
                {initialDep.day}
              </span>{" "}
              <span id="dep_monthYear" className="fs-14">
                {initialDep.monthYear}
              </span>
              <br />
              <span id="dep_dayName">{initialDep.dayName}</span>
              <input
                type="text"
                id="departureDate"
                className="hidden-datepicker-input"
                readOnly
              />
            </div>
          </div>

          {/* Check-Out */}
          <div className="Destnion_date">
            <p>
              <i className="fa fa-calendar-days"></i> Check-Out
            </p>

            <div
              className="dest_nam cursor-pointer"
              id="dateDisplay2"
              onClick={() => $("#returnDate").datepicker("show")}
            >
              <span id="ret_dayNum" className="fs-28 font-bold">
                {initialRet.day}
              </span>{" "}
              <span id="ret_monthYear" className="fs-14">
                {initialRet.monthYear}
              </span>
              <br />
              <span id="ret_dayName">{initialRet.dayName}</span>
              <input
                type="text"
                id="returnDate"
                className="hidden-datepicker-input"
                readOnly
              />
            </div>
          </div>

          {/* Nationality */}
          <div className="Destnion_date">
            <p>
              <i className="fa fa-flag"></i> Nationality
            </p>
            <div className="detinion">
              <select
                className="form_control_hotel border-0 p-0 w-100 bg-transparent nationality-select"
                value={nationality}
                onChange={(e) => setNationality(e.target.value)}
                style={{
                  appearance: "none",
                  outline: "none",
                  cursor: "pointer",
                  marginTop: 14,
                  fontSize: "22px",
                  fontWeight: "600",
                }}
              >
                {countryData.nationalityInfos.map((c) => (
                  <option key={c.countryId} value={c.countryId}>
                    {c.countryName}
                  </option>
                ))}
              </select>
              {/* <div className="fs-12 text-muted">Selected Country</div> */}
            </div>
          </div>

          {/* Star Category */}
          <div
            className="Destnion_date pos-relative"
            onClick={(e) => {
              e.stopPropagation();
              setShowStarDropdown(!showStarDropdown);
            }}
            style={{ cursor: "pointer" }}
          >
            <p>
              <i className="fa fa-star text-warning"></i> Star
            </p>
            <div className="dest_nam select_star_category" style={{ fontSize: "22px", fontWeight: "600", marginTop: 14 }}>
              {starRatings.length === 0
                ? "All Stars"
                : starRatings.length === 5
                ? "All Stars"
                : `${starRatings.sort().join(", ")} Star`}
              <img
                src="/assets/images/down.png"
                className="down"
                alt="arrow"
                style={{ width: 12, height: 8, marginLeft: 8, marginTop: 0, verticalAlign: "middle" }}
              />
            </div>
            
            {showStarDropdown && (
              <div
                className="star-rating-dropdown"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  width: "200px",
                  background: "#fff",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                  borderRadius: "6px",
                  padding: "12px",
                  zIndex: 1000,
                  marginTop: "8px",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {[1, 2, 3, 4, 5].map((star) => {
                  const val = star.toString();
                  const isChecked = starRatings.includes(val);
                  return (
                    <div className="form-check mb-2" key={star}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`search-star-${star}`}
                        checked={isChecked}
                        onChange={() => {
                          setStarRatings((prev) =>
                            prev.includes(val)
                              ? prev.filter((s) => s !== val)
                              : [...prev, val]
                          );
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <label
                        className="form-check-label ms-2 cursor-pointer"
                        htmlFor={`search-star-${star}`}
                        style={{ color: "#110942", fontWeight: "600" }}
                      >
                        {star} Star
                      </label>
                    </div>
                  );
                })}
                <div className="border-top pt-2 mt-2 text-end">
                  <button
                    className="btn btn-sm btn-primary done_selcts"
                    onClick={() => setShowStarDropdown(false)}
                    style={{ fontSize: "11px", padding: "3px 10px" }}
                  >
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Rooms & Guests */}
          <div
            className="Rooms_Guests showSelect"
            onClick={(e) => {
              e.stopPropagation();
              setShowDropdown(!showDropdown);
            }}
          >
            <p>
              <i className="fa fa-users"></i> Rooms & Guests
            </p>
            <div className="pax_no">
              <div className="Adlt_pax">
                {rooms.length} <span>Room</span>
              </div>
              <div className="Adlt_pax">
                {totalGuests} <span>Guests</span>
              </div>
              <img
                src="/assets/images/down.png"
                className="down"
                alt="flight"
              />
            </div>
            <div className="traveller-calulate-persons">
              <div className="se_l_d-flex">
                <div className="d-flex-lft">
                  {rooms.reduce((sum, r) => sum + r.adults, 0)} Adult
                </div>
                <div className="d-flex-rgt">
                  {rooms.reduce((sum, r) => sum + r.children, 0)} Child
                </div>
              </div>
            </div>

            {/* Dropdown */}
            <div
              className="hotel dropdown_passenger_info hotel-dropdown-container"
              id="toggle_dropdown"
              style={{
                display: showDropdown ? "block" : "none",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="traveller-calulate-persons">
                {/* Scrollable Room List */}
                <div className="max-h-350 overflow-y-auto pr-1">
                  {rooms.map((room, index) => (
                    <div className="passengers" key={index}>
                      <h6>Room {index + 1}</h6>

                      {/* ADULTS */}
                      <div className="passengers-type">
                        <div className="text">
                          <div className="type-label">
                            <p>Adult</p>
                            <span>12+ yrs</span>
                          </div>
                        </div>

                        <div className="button-set">
                          <select
                            value={room.adults}
                            onChange={(e) =>
                              updateRoom(index, "adults", e.target.value)
                            }
                            className="form-select form-select-solid"
                          >
                            {[1, 2, 3, 4, 5].map((n) => (
                              <option key={n} value={n}>
                                {n}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* CHILDREN */}
                      <div className="passengers-type">
                        <div className="text">
                          <div className="type-label">
                            <p>Children</p>
                            <span>0 - 17 yrs</span>
                          </div>
                        </div>

                        <div className="button-set">
                          <select
                            value={room.children}
                            onChange={(e) =>
                              updateRoom(index, "children", e.target.value)
                            }
                            className="form-select form-select-solid"
                          >
                            {[0, 1, 2, 3, 4].map((n) => (
                              <option key={n} value={n}>
                                {n}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* CHILD AGES */}
                      {room.children > 0 && (
                        <div className="child-age-box">
                          <p className="child-age-label">Child Ages</p>
                          <div className="d-flex flex-wrap">
                            {room.childAges.map((age, childIdx) => (
                              <div key={childIdx} className="child-slot">
                                <span className="fs-10 d-block">
                                  Child {childIdx + 1}
                                </span>
                                <select
                                  value={age}
                                  onChange={(e) =>
                                    updateRoom(index, "childAge", {
                                      childIndex: childIdx,
                                      age: e.target.value,
                                    })
                                  }
                                  className="form-select form-select-sm fs-12"
                                  style={{ width: "65px" }}
                                >
                                  {[...Array(17).keys()].map((n) => (
                                    <option key={n + 1} value={n + 1}>
                                      {n + 1} Year
                                    </option>
                                  ))}
                                </select>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* Fixed Footer Buttons */}
                <div className="col-12 mt-3 pt-2 border-top-eee d-flex flex-wrap">
                  <button
                    className="btn btn-primary btn-sm m-1"
                    onClick={addRoom}
                    disabled={rooms.length === MAX_ROOMS}
                  >
                    Add Room
                  </button>

                  <button
                    className="btn btn-primary btn-sm m-1"
                    onClick={removeRoom}
                    disabled={rooms.length === 1}
                  >
                    Remove Room
                  </button>
                  <button
                    className="btn btn-danger btn-sm done_selcts m-1"
                    onClick={() => setShowDropdown(false)}
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* SEARCH BUTTON */}
          <div className="Rooms_Guests_Serch">
            <button className="Serch btn-link w-full" onClick={handleSearch}>
              Search
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default HotelSearch;
